import $http from '@/module/http';

let info = null;
let countries = null;
let tags = null;
let choices = null;
let membership = null;
let racks = null;
// 按 packageId 缓存 package 详情请求 promise，避免 Breadcrumbs 和 PackageDetail 重复请求
let packageDetailMap = {};
export default {
  strict: true,
  namespaced: true,
  state: {
    racks: [],
    clientInfo: {
      id: '',
      credit_info: {}
    },
    tags: [],
    choices: {},
    utmInfo: {}
  },
  mutations: {
    setClientInfo(state, payload) {
      state.clientInfo = Object.assign({}, state.clientInfo, payload);
    },
    setTags(state, payload) {
      state.tags = payload;
    },
    setChoices(state, payload) {
      state.choices = payload;
    },
    setRacks(state, payload) {
      state.racks = payload;
    },
    setUTMSourceInfo(state, payload) {
      state.utmInfo.source = payload;
    },
    setUTMMediumInfo(state, payload) {
      state.utmInfo.medium = payload;
    }
  },
  actions: {
    getClientInfo: ({ commit }, { force = false, clientId }) => {
      if (!force && info) {
        return info;
      }
      info = $http.get(`clients/${clientId}/`).then((res) => {
        commit('setClientInfo', res);
        return res;
      });
      return info;
    },
    // 共享同一个 in-flight promise, 让 Breadcrumbs 和 PackageDetail 只发一次请求
    getPackageDetail: (_, { packageId, force = false } = {}) => {
      if (!packageId) {
        return Promise.reject(new Error('packageId is required'));
      }
      if (force || !packageDetailMap[packageId]) {
        packageDetailMap[packageId] = $http.get(`packages/${packageId}/`).catch((e) => {
          // 失败时清掉缓存, 避免持续命中失败 promise
          delete packageDetailMap[packageId];
          return Promise.reject(e);
        });
      }
      return packageDetailMap[packageId];
    },
    getCountries: () => {
      if (!countries) {
        countries = $http
          .get(`/countries/`, {
            params: {
              page_size: 300
            }
          })
          .then((res) => {
            return Promise.resolve(res.results);
          });
      }
      return Promise.resolve(countries);
    },
    getTags: ({ commit }, force = false) => {
      if (!tags || force) {
        tags = $http
          .get(`/tags/`, {
            params: {
              page_size: 300
            }
          })
          .then((res) => {
            commit('setTags', res.results);
            return Promise.resolve(res.results);
          });
      }
      return Promise.resolve(tags);
    },
    getDbmEmailChoices: ({ commit }, force = false) => {
      if (!choices || force) {
        choices = $http.get(`client_bulk_mail_tasks/get_dbm_pre_data/`).then((res) => {
          commit('setChoices', res);
          return Promise.resolve(res);
        });
      }
      return Promise.resolve(choices);
    },
    getPackageUTMInfo: ({ commit }, { productType = '', columnName = 'utm_source' }) => {
      return $http
        .get(`/utminfodistinctvalues/`, {
          params: {
            model_name: 'packages.PackageUTMInfo',
            column_name: columnName,
            product_type: productType
          }
        })
        .then((res) => {
          commit('setUTMSourceInfo', res);
          return Promise.resolve(res);
        });
    },
    getCLientUTMInfo: ({ commit }, { columnName = 'utm_source' }) => {
      return $http
        .get(`/utminfodistinctvalues/`, {
          params: {
            model_name: 'clients.ClientUTMInfo',
            column_name: columnName
          }
        })
        .then((res) => {
          commit('setUTMMediumInfo', res);
          return Promise.resolve(res);
        });
    },
    getMemberships: (context, force = false) => {
      if (!membership || force) {
        membership = $http.get(`/memberships/`).then((res) => {
          return Promise.resolve(res.results);
        });
      }
      return membership;
    },
    getRacks: ({ commit }, force = false) => {
      if (!racks || force) {
        racks = $http
          .get(`/device_racks/`)
          .then((res) => {
            commit('setRacks', res.results);
            return Promise.resolve(res.results);
          })
          .catch((e) => {
            return Promise.reject(e);
          });
      }
      return Promise.resolve(racks);
    }
  }
};
